/** In-app Periodic Health Assessment (service member) route. */
export const SERVICE_MEMBER_ROUTE = '/service-member';

/** Query key for examineeProfileId-caseId-examId. */
export const SERVICE_MEMBER_ACCOUNT_QUERY = 'account';

/** Dashboard deep-link display name for the selected service member. */
export const SERVICE_MEMBER_NAME_QUERY = 'smName';

/** Query key that selects the Part A entry experience. */
export const SERVICE_MEMBER_TEST_KEY_QUERY = 'testKey';

/** Static testKey for Service Member → Part A entry. */
export const SERVICE_MEMBER_PART_A_ENTRY_TEST_KEY = 'part_a_entry';

/** Display rank when Flowable does not provide rank (SM portal chrome). */
export const SERVICE_MEMBER_DISPLAY_RANK_ABBR = 'SSgt';

/** Full rank label paired with SERVICE_MEMBER_DISPLAY_RANK_ABBR. */
export const SERVICE_MEMBER_DISPLAY_RANK = 'Staff Sergeant';

/**
 * Demo Service Member (Jane Doe on HCP) — caseId from account middle segment.
 * Example: /service-member?account=126-705-718&testKey=part_a_entry&efid=998
 * Mock Service Branch chrome for this member.
 */
export const SERVICE_MEMBER_DEMO_AIR_FORCE_CASE_ID = 705;

/** Mock Service Branch label for SERVICE_MEMBER_DEMO_AIR_FORCE_CASE_ID. */
export const SERVICE_MEMBER_DEMO_AIR_FORCE_BRANCH = 'Air Force';
